// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"07fe2d23","455":"1f2404d0","977":"63ffb136"}[chunkId] + ".chunk.js";
};